import { type FC } from 'react';

// MUI
import TableContainer from '@mui/material/TableContainer';
import Typography from '@mui/material/Typography';

// screeen
import { DailyInvoiceModel } from 'modules/map/components/daily-consolidate-invoice/types';
import {
  ORIGINAL_FONT_SIZE,
  sharedPrintTableStyles,
  SMALL_FONT_SIZE,
} from 'modules/map/components/pdf-print-form/utils';
import PdfDailyConsolidateInvoiceTable from 'modules/map/components/daily-consolidate-invoice/pdf/PdfConsolidateInvoiceTable';
import PrintThemeWrapper from 'modules/map/components/pdf-print-form/PrintThemeWrapper';
import MenuInDay from 'modules/map/components/daily-consolidate-invoice/pdf/MenuInDay';
import PdfFormNote from 'modules/map/components/pdf-print-form/styled-components/PdfFormNote';

interface PdfDailyConsolidateInvoiceProp {
  data: DailyInvoiceModel;
}

const PdfDailyConsolidateInvoice: FC<PdfDailyConsolidateInvoiceProp> = ({ data }) => {
  return (
    <PrintThemeWrapper>
      <style>
        {`
          @media print {
            @page {
              size: A4 portrait;
            }
          }
        `}
      </style>
      <TableContainer className="px-2 tablet:px-4 space-y-4" sx={sharedPrintTableStyles}>
        <Typography
          sx={{
            mt: 2,
            textAlign: 'center',
            fontSize: SMALL_FONT_SIZE,
            fontWeight: 600,
          }}
        >
          {data?.structuredData.data.info.title || ''}
        </Typography>
        <MenuInDay data={data?.structuredData} />
        <PdfFormNote
          content={data?.structuredData.data.info.mealPrice}
          sx={{ fontSize: ORIGINAL_FONT_SIZE }}
        />
        <PdfDailyConsolidateInvoiceTable data={data} />
      </TableContainer>
    </PrintThemeWrapper>
  );
};

export default PdfDailyConsolidateInvoice;
